import { render, staticRenderFns } from "./CountryLangChoice.vue?vue&type=template&id=3f5166c4&lang=pug"
import script from "./CountryLangChoice.vue?vue&type=script&lang=js"
export * from "./CountryLangChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports